const AVAILABLE_LANGUAGES = ["Français", "Anglais"];
const AVAILABLE_TIMES = [];
for (let i = 0; i < 23; ++i) {
    const twoDigitHour = String(i).padStart(2, '0');
    AVAILABLE_TIMES.push(`${twoDigitHour}:00`);
    AVAILABLE_TIMES.push(`${twoDigitHour}:30`);
}
export { AVAILABLE_LANGUAGES, AVAILABLE_TIMES };
